"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var classnames_1 = __importDefault(require("classnames"));

var react_1 = __importDefault(require("react"));

var close_big_svg_1 = __importDefault(require("svgson-loader!@paradigm/icons/src/mailru/actions/close_big.svg"));

var baseProps_1 = __importDefault(require("../assets/baseProps"));

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var Icon_1 = __importDefault(require("../Icon/Icon"));

var Text_1 = __importDefault(require("../Text/Text"));

var ExpansionItem_1 = __importDefault(require("./ExpansionItem"));

var ExpansionPanel_styles_1 = require("./ExpansionPanel.styles");

var NakedExpansionItem = ExpansionItem_1.default.NakedComponent;

var ExpansionPanel =
/** @class */
function (_super) {
  __extends(ExpansionPanel, _super);

  function ExpansionPanel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.items = {};

    _this.onToggle = function (key, unfolded) {
      /* istanbul ignore else */
      if (_this.items[key]) {
        _this.items[key].unfolded = unfolded;

        if (unfolded && !_this.props.multiple) {
          Object.keys(_this.items).forEach(function (k) {
            if (k !== key) {
              _this.items[k].unfolded = false;
            }
          });
        }

        _this.forceUpdate();
      }
    };

    return _this;
  }

  Object.defineProperty(ExpansionPanel.prototype, "content", {
    // eslint-disable-next-line sonarjs/cognitive-complexity
    get: function get() {
      var _this = this;

      var _a = this.props,
          manual = _a.manual,
          items = _a.items,
          children = _a.children;

      if (manual) {
        return items || children;
      }

      return react_1.default.Children.map(items || children, function (child) {
        var isExpansionItem = false;

        if (child && typeof child.type !== 'undefined') {
          var childElement_1 = child;

          if (childElement_1.type && childElement_1.type.NakedComponent === NakedExpansionItem) {
            isExpansionItem = true;
          }
        }

        if (!isExpansionItem) {
          return child;
        }

        var childElement = child;

        if (!childElement.key) {
          throw new Error('You must specify the key property of ExpansionItem to use the ExpansionPanel in automatic mode.');
        }

        var key = childElement.key.toString();

        if (!_this.items[key]) {
          _this.items[key] = {
            element: childElement,
            unfolded: childElement.props.unfolded || false
          };
        }

        return react_1.default.cloneElement(childElement, {
          unfolded: _this.items[key].unfolded,
          onToggle: function onToggle(unfolded) {
            return _this.onToggle(key, unfolded);
          }
        });
      });
    },
    enumerable: false,
    configurable: true
  });

  ExpansionPanel.prototype.render = function () {
    var _a;

    var _b = this,
        props = _b.props,
        content = _b.content;

    var header = props.header,
        footer = props.footer,
        popup = props.popup,
        onCloseCrossClick = props.onCloseCrossClick,
        responsive = props.responsive,
        classes = props.classes;
    var panelClassName = classnames_1.default(classes.panel, (_a = {}, _a[classes.mobile] = responsive === 'mobile', _a[classes.auto] = responsive === 'auto', _a));
    return react_1.default.createElement("div", __assign({}, baseProps_1.default(props), {
      className: panelClassName
    }), header && react_1.default.createElement("div", {
      "data-test-id": "expansion-panel-header",
      className: classes.header
    }, typeof header === 'string' ? react_1.default.createElement(Text_1.default, {
      mode: "h1"
    }, header) : header), content, footer && react_1.default.createElement("div", {
      "data-test-id": "expansion-panel-footer",
      className: classes.footer
    }, footer), popup && react_1.default.createElement("div", {
      "data-test-id": "expansion-panel-cross",
      className: classes.cross,
      onClick: onCloseCrossClick
    }, react_1.default.createElement(Icon_1.default, {
      icon: close_big_svg_1.default
    })));
  };

  ExpansionPanel = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(ExpansionPanel_styles_1.styles)], ExpansionPanel);
  return ExpansionPanel;
}(react_1.default.PureComponent);

exports.default = ExpansionPanel;